module.exports = __webpack_public_path__ + "img/kaishou2.7b2e690f.png";